import React from 'react'
import { useNavigate } from 'react-router-dom'
import Icon from './Icon'
import { sendDataLayer } from '../../utils/functions'

function Button({
  type,
  text,
  loading,
  status,
  onClick,
  link,
  external,
  icon,
  datalayer
}) {
  const navigate = useNavigate()
  const handler = () => {

    if(datalayer) {
      sendDataLayer({datalayer})
    }

    if (status === 'active' && !loading) {
      link
          ? external
            ? window.open(link, '_blank')
            : navigate(link)
          : onClick 
            ? onClick()
            : console.log("No se ejecuta nada")
    }
  }

  return (
    <div
      className={`mc-button-container mc-button-container__${type}`}
      onClick={handler}
    >
      <button className={`slow_ani mc-button-container__status--${status}`}>
        {loading
          ? <img src='/assets/images/preloader_1.gif' alt='loader' className='inline-loader' />
          : icon 
            ? <>{text}<Icon name={icon}/></>
            : text
        }
      </button>
    </div>
  )
}

export default Button